import styled from 'styled-components';

export const StyledListingImageWrapper = styled.div`
  grid-column: 1/-1;
  grid-row: 1/2;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
`;
export const DesktopStyledListingImageWrapper = styled.div`
  grid-column: 1/2;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
`;

export const DesktopStyledFreeCancellationWrapper = styled.div`
  margin: 0 0 6px auto;
  grid-row: 2/3;
`;
export const DesktopChippinWrapper = styled.div`
  margin: 0 0 8px auto;
  grid-row: 2/3;
  margin-top: 8px;
`;
